import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-review_default",
  "use": "icon-review_default-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-review_default\"><defs><style>#icon-review_default .a{fill:#3482f9;}#icon-review_default .b{fill:#fff;}</style></defs><g transform=\"translate(7943 -1227)\"><circle class=\"a\" cx=\"8\" cy=\"8\" r=\"8\" transform=\"translate(-7943 1227)\" /><rect class=\"b\" width=\"10\" height=\"2\" rx=\"1\" transform=\"translate(-7940 1234)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol